import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
import VideoCardContent from './content/video/card-content';
import ProductCardContent from './content/product/card-content';
import SocialCardContent from './content/social/card-content';
import styles from './card.scss';
export default class VideoCard extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onCardClick", () => {
      const {
        cardData,
        onCardClick
      } = this.props;
      onCardClick(cardData);
    });
  }
  getCardAriaLabel() {
    const {
      cardData,
      labels
    } = this.props;
    switch (cardData.network) {
      case 'twitter':
        return cardData.text + " " + labels.twitterButtonTitle;
      case 'youtube':
        return cardData.text + " " + labels.youtubeButtonTitle;
      case 'facebook':
        return cardData.text + " " + labels.facebookButtonTitle;
      default:
        return undefined;
    }
  }
  getContentComponent(type) {
    const {
      CHANNEL,
      VIDEO,
      RECENT_VIDEO,
      CUSTOM,
      PRODUCT,
      SOCIAL
    } = VIDEO_CARD_TYPES;
    switch (type) {
      case CHANNEL:
      case VIDEO:
      case RECENT_VIDEO:
        return VideoCardContent;
      case CUSTOM:
      case PRODUCT:
        return ProductCardContent;
      case SOCIAL:
        return SocialCardContent;
      default:
        return ProductCardContent;
    }
  }
  renderCardContent() {
    const {
      cardData,
      isMobile,
      isAccessible,
      labels
    } = this.props;
    const {
      type,
      text,
      thumbnailUrl,
      buttonLabel
    } = cardData;
    const typeClassName = styles["card-type-" + type];
    const partsClasses = {
      [styles['without-text']]: !text,
      [styles['without-thumbnail']]: !thumbnailUrl,
      [styles['without-cta']]: !buttonLabel
    };
    const cardClassName = classnames(styles.card, typeClassName, partsClasses);
    const CardContentComponent = this.getContentComponent(cardData.type);
    return /*#__PURE__*/React.createElement(CardContentComponent, {
      className: cardClassName,
      cardData: cardData,
      isAriaHidden: isMobile,
      isAccessible: isAccessible,
      labels: labels
    });
  }
  renderMobileCard() {
    const {
      cardData
    } = this.props;
    return /*#__PURE__*/React.createElement("a", {
      className: classnames(styles.link, styles['link-mobile']),
      href: cardData.url,
      tabIndex: 0,
      role: "option",
      "aria-selected": "true",
      "aria-label": this.getCardAriaLabel(),
      rel: "noopener noreferrer",
      onClick: this.onCardClick,
      target: "_blank"
    }, this.renderCardContent());
  }
  renderPlayerCard() {
    const {
      isAccessible,
      cardData
    } = this.props;
    return /*#__PURE__*/React.createElement("a", {
      className: styles.link,
      href: cardData.url,
      "aria-hidden": !isAccessible,
      tabIndex: isAccessible ? 0 : -1,
      rel: "noopener noreferrer",
      onClick: this.onCardClick,
      "data-hook": "card-button",
      target: "_blank"
    }, this.renderCardContent());
  }
  render() {
    const {
      isMobile
    } = this.props;
    return isMobile ? this.renderMobileCard() : this.renderPlayerCard();
  }
}
_defineProperty(VideoCard, "defaultProps", {
  onCardClick: noop,
  labels: {}
});
//# sourceMappingURL=card.js.map